import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { addLicense, removeLicense } from 'Pods/SearchPage/Store/actions/licenses'
import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { getLicenseFiltersConfig } from './constants'

function LicenseContent() {
  const translate = useTranslate()

  const licenses = useSearchPageStore(state => state.licenses ?? [LICENSE_TYPE.ALL])
  const trackFilterSelect = useTrackFilterSelect()

  const handleLicenseFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      trackFilterSelect(FILTER_NAME.LICENSE, value)
      addLicense(value)
    } else {
      removeLicense(value)
    }
  }, [trackFilterSelect])

  const licenseFiltersConfig = useMemo(() => getLicenseFiltersConfig(translate), [translate])

  return (
    <FiltersSidebar
      isCollapsible={false}
      filters={licenseFiltersConfig}
      selectedFilters={licenses}
      onFiltersChange={handleLicenseFilterChange}
      hideLastDivider
      isControlled
      useNewCheckboxes
      hideShowMore
      baseFormWrapperClassName="filter-wrapper__content"
    />
  )
}

export default memo(LicenseContent)
